import { SortOrder, SortAs } from '@ocean/types/dist/sort'
import { SortUtils } from '@ocean/utils'
import {
  SimulatorTraining,
  SimulatorTrainingTypeReference,
} from 'modules/simulatorTrainings/instructor/instructorLed/SimulatorList/types'

class SimulatorListUtils {
  getSimulatorTypes(simulators: SimulatorTraining[]): SimulatorTrainingTypeReference[] {
    let typesObj: Record<string, string> = {}

    simulators.forEach(({ type, typeName }) => {
      if (!typesObj[type]) typesObj[type] = typeName
    })

    // TODO: Migration on DictionariesUtils.createDictionaryFromObject?
    const references = Object.keys(typesObj).map(type => ({
      id: Number(type),
      name: typesObj[type],
    }))

    return [...references].sort(
      SortUtils.sortByMultipleKeys(['name'], SortOrder.Ascending, SortAs.String)
    )
  }
}

export default new SimulatorListUtils()
